'use client';

import { Container } from '@mui/material';
import { RequestPasswordResetForm } from './RequestPasswordResetForm';
import { InputSecurityCodeForm } from './InputSecurityCodeForm';
import { useLogic } from './logic';
import { ResetPasswordForm } from './ResetPasswordForm';

export function PasswordResetBox({ checkToken }: { checkToken?: string }) {
  const { tmpToken, setTmpToken } = useLogic();
  return (
    <Container>
      {!checkToken ? (
        <RequestPasswordResetForm />
      ) : !tmpToken ? (
        <InputSecurityCodeForm setTmpToken={setTmpToken} />
      ) : (
        <ResetPasswordForm tmpToken={tmpToken} />
      )}
    </Container>
  );
}
